import './javascripts/_google_map.js';
import './javascripts/_area_partner_anchor.js';
import './javascripts/_area_partner_select.js';
import './javascripts/_area_partner_scheda_partner.js';
